var map = {
	"./Coccolhitophorids_CalState.jpg": 2320,
	"./Coocoliths_1.jpg": 3362,
	"./Coocoliths_3.jpg": 5397,
	"./Gephyrocapsa_oceanic_004.jpg": 5051,
	"./coccolith.jpg": 1321,
	"./coccolith_001.jpg": 2470,
	"./coccolith_002.jpg": 7090,
	"./coccolith_003.jpg": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8603;